import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorBannerProps {
  message: string;
  onDismiss?: () => void;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, onDismiss }) => (
  <div
    className="mb-4 flex items-start gap-3 rounded-lg border border-red-800 bg-red-950/40 px-4 py-3 text-red-200"
    role="alert"
  >
    <AlertCircle className="h-5 w-5 shrink-0 mt-0.5" aria-hidden />
    <p className="flex-1 text-sm">{message}</p>
    {onDismiss && (
      <button
        type="button"
        onClick={onDismiss}
        className="text-xs text-red-300 hover:text-white"
      >
        Dismiss
      </button>
    )}
  </div>
);

export default ErrorBanner;
